import { Button } from '../../../components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';

interface ViewerButtonProps {
  studyInstanceUID?: string | null;
}

function buildOhifStudyUrl(studyInstanceUID: string) {
  const viewer = (window as any)?.data?.viewer ?? {};
  const base = String(viewer.ohifBaseUrl ?? '').trim();
  const template = String(viewer.studyUrlTemplate ?? '').trim();

  if (!base) return null;

  const normalizedBase = base.replace(/\/+$/, '');
  if (template) {
    return template.replace(/\{StudyInstanceUID\}/g, encodeURIComponent(studyInstanceUID));
  }

  return `${normalizedBase}/viewer?StudyInstanceUIDs=${encodeURIComponent(studyInstanceUID)}`;
}

export const ViewerButton: React.FC<ViewerButtonProps> = ({ studyInstanceUID }) => {
  const uid = (studyInstanceUID ?? '').trim();
  const url = uid ? buildOhifStudyUrl(uid) : null;

  const isDisabled = !uid || !url;
  const tooltip = !uid
    ? 'Study Instance UID not available'
    : !url
      ? 'Viewer URL not configured (set viewer.ohifBaseUrl in public/config.json)'
      : 'Open study in viewer';

  const handleOpen = () => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <Button
              variant="outline"
              className="flex w-auto hover:bg-slate-900 hover:text-white transition-colors rounded"
              onClick={handleOpen}
              disabled={isDisabled}
            >
              Viewer
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <span>{tooltip}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

